"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Landing = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("./styled");
const Landing = () => {
    return ((0, jsx_runtime_1.jsx)(styled_1.StyledContainer, { children: (0, jsx_runtime_1.jsx)("a", { href: "https://gemunion.io", children: (0, jsx_runtime_1.jsx)(styled_1.StyledLogo, { component: "img", src: "/logo.png", alt: "GEMUNION" }) }) }));
};
exports.Landing = Landing;
//# sourceMappingURL=index.js.map